import { Link } from "react-router-dom";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  { label: "Our Approach", to: "/approach" },
  { label: "About Us", to: "/about" },
  { label: "Careers", to: "/careers" },
  { label: "Contact Us", to: "/contact" },
];

export default function Footer() {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="grain relative bg-ink px-6 pb-10 pt-20 lg:px-12" data-testid="footer">
      <div className="relative z-10 mx-auto max-w-[1440px]">
        <button onClick={toTop} data-testid="footer-scroll-top" className="block w-full text-left" aria-label="Back to top">
          <p className="font-serif text-[9vw] leading-none text-paper/90 transition-colors duration-500 hover:text-paper lg:text-[5.5vw]">
            Building <em className="italic">experiences,</em>
            <br />
            <span className="text-stroke-paper">not just spaces.</span>
          </p>
        </button>

        <div className="mt-16 flex flex-col justify-between gap-10 border-t border-paper/15 pt-10 lg:flex-row lg:items-center">
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[11px] font-medium uppercase tracking-[0.2em] text-paper/60 transition-colors duration-300 hover:text-paper"
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <a
            href="mailto:hello@araturnkey.com"
            data-testid="footer-email"
            className="text-[11px] font-medium uppercase tracking-[0.2em] text-paper/60 transition-colors duration-300 hover:text-paper"
          >
            hello@araturnkey.com
          </a>
        </div>

        <div className="mt-10 border-t border-paper/10 pt-6">
          <p className="text-[11px] text-paper/40">© {new Date().getFullYear()} ARA Turnkey Projects Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
